import MasterPlanSvg from '@assets/images/svg/master-plan.svg';
import React from 'react';

export interface MasterPlanIconProps {
  size?: number;
  color?: string;
}

/** Folded map / master plan icon from Figma. */
export function MasterPlanIcon({
  size = 24,
  color = '#333333',
}: Readonly<MasterPlanIconProps>) {
  return <MasterPlanSvg width={size} height={size} color={color} />;
}

export default MasterPlanIcon;
